import { useQuery } from '@tanstack/react-query';
import { QueryKey } from '../../query-client';
import { fetchMarketZones, identifyMarketZone } from './index';
import { IIdentifyMarketZoneQuery } from './interface';
import { IMarket } from './IMarket';

// Api returns market lowercase, and zones uppercase
export const useMarketZoneListQuery = (options?: {}) => {
    return useQuery<{ [market: string]: string[] }, Error>([QueryKey.MARKET_ZONES], ({ signal }) => fetchMarketZones(signal), {
        ...options,
    });
};

export const useIdentifyMarketZoneQuery = (query: IIdentifyMarketZoneQuery, options?: {}) => {
    return useQuery<IMarket | null, Error>([QueryKey.IDENTIFY_MARKET_ZONE, query], ({ signal }) => identifyMarketZone(query, signal), {
        ...options,
    });
};
